class UserInfo {
  static getUser() {
    const userData = localStorage.getItem("user_info");

    if (!userData) {
      return null;
    }

    try {
      return JSON.parse(userData);
    } catch (error) {
      console.error("Invalid user data in localStorage");
      return null;
    }
  }

  static countryId() {
    const user = this.getUser();
    const countryData = user.countries.find((info) => !!info.main);
    return countryData.countryId || null;
  }

  static countryInfo() {
    const user = this.getUser();
    const countryData = user.countries.find((info) => !!info.main);
    return countryData || null;
  }

  static countryListForFilter(t) {
    const user = this.getUser();
    const countryArray = [];
    user.countries.map((countryInfo) => {
      countryArray.push({
        label: t(countryInfo.country.name),
        value: countryInfo.country.id,
      });
    });
    return countryArray;
  }
}

export default UserInfo;
